module.exports = __webpack_public_path__ + "share_bottom.6a20614f.png";